import customerShowComponent from './customer-show.component';

const customerShowModule = angular.module('customerShow', [
])
  .component('customerShow', customerShowComponent)
  .name;

export default customerShowModule;
